// extracted by mini-css-extract-plugin
export default {"card":"Report_card__XiByD"};